import type { TJobsFilter } from 'app/types/TJobsFilter';
import type { TransactionRow } from '../types/TransactionRow';

type TOptions = {
  search: string;
  filter: TJobsFilter;
};

export const filterTransactionRows = (rows: TransactionRow[], { search, filter }: TOptions) => {
  const normalizedSearch = search.trim().toLowerCase();
  const fromTime = filter?.from ? new Date(filter.from).getTime() : undefined;
  const toTime = filter?.to ? new Date(filter.to).getTime() : undefined;

  return rows.filter((transaction) => {
    const createdAtTime = new Date(transaction.createdAt).getTime();
    if (fromTime && createdAtTime < fromTime) {
      return false;
    }
    if (toTime && createdAtTime > toTime) {
      return false;
    }
    if (!normalizedSearch) {
      return true;
    }
    const haystack = [
      transaction.title,
      transaction.code?.code,
      transaction.codeId,
      transaction.description,
      transaction.stripeChargeId,
      transaction.jobId,
    ]
      .filter(Boolean)
      .map((value) => value!.toString().toLowerCase());

    return haystack.some((item) => item.includes(normalizedSearch));
  });
};
